import { determine } from 'jstimezonedetect';
export const SECONDS_IN_MINUTE = 60;
export const MILLISECONDS_IN_SECOND = 1000;
export const MILLISECONDS_IN_MINUTE = SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
export const MICROSECONDS_IN_SECOND = 1000000;
export const MICROSECONDS_IN_MILLISECOND = 1000;
export const HOURS_IN_DAY = 24;
export const MINUTES_IN_HOUR = 60;
export const DAYS_IN_WEEK = 7;
export const MINUTES_IN_DAY = MINUTES_IN_HOUR * HOURS_IN_DAY;
export const MINUTES_IN_WEEK = MINUTES_IN_DAY * DAYS_IN_WEEK;

// Does not account for leap seconds
export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * MINUTES_IN_HOUR;
export function convertSecondsToHours(seconds) {
  return String(Math.round(Number(seconds) / 36) / 100);
}
export function convertHoursToMinutes(hours) {
  return hours * MINUTES_IN_HOUR;
}
export function convertDaysToMinutes(days) {
  return days * MINUTES_IN_DAY;
}
export function convertWeeksToMinutes(weeks) {
  return weeks * MINUTES_IN_WEEK;
}
export function convertSecondsToMinutes(seconds) {
  // Takes in seconds, returns minutes rounded. Shows max 2 decimal places
  return String(Math.round(Number(seconds) / SECONDS_IN_MINUTE * 100) / 100);
}
export function convertMillisecondsToSeconds(milliseconds) {
  return milliseconds / MILLISECONDS_IN_SECOND;
}
export function convertMicrosecondsToMilliseconds(microseconds) {
  return microseconds / MICROSECONDS_IN_MILLISECOND;
}
export function convertMinutesToMilliseconds(minutes) {
  return minutes * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
}
export function convertMillisecondsToSecondsCeil(milliseconds) {
  return Math.ceil(convertMillisecondsToSeconds(milliseconds));
}
export function convertMillisecondsToMicroseconds(milliseconds) {
  return milliseconds * MICROSECONDS_IN_MILLISECOND;
}

// Hours are calculated by rounding each clock time down to the minute, then
// subtracting and rounding to 2 decimal places
// See: https://jira.sqcorp.co/browse/RPS-1422 and go/rounding
export function convertClockInOutToHoursRounded(clockInSeconds, clockOutSeconds) {
  clockInSeconds -= clockInSeconds % 60; // eslint-disable-line no-param-reassign
  clockOutSeconds -= clockOutSeconds % 60; // eslint-disable-line no-param-reassign
  return convertSecondsToHours(clockOutSeconds - clockInSeconds);
}
let browserTimeZone = null;

/**
 * Sets the stubbed name of the current browser time zone.
 * @param {string} name An IANA time zone name.
 */
export function setBrowserTimeZoneStub(name) {
  browserTimeZone = name;
}

/**
 * Clears the stubbed name of the current browser time zone.
 */
export function clearBrowserTimeZoneStub() {
  browserTimeZone = null;
}

/**
 * Returns the current stubbed time zone name or the real one if no stub is set.
 * @returns {string} e.g. "America/Los_Angeles"
 */
export function getBrowserTimeZone() {
  return browserTimeZone || determine().name();
}